import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { OutcomesService } from './outcomes.service';
import { AssetManagementService } from './asset-management.service';
import { ProjectsService } from './projects.service';
import { AuthorService } from './author.service';
import { AuthenticationService } from './authentication.service';
import { ignoreElements } from 'rxjs/operators';
import { LearnerService } from './learner.service';
import { CustomerUsageService } from './customer-usage.service';
import { CustomerService } from './customer.service';
import { CryptoService } from './crypto.service';
import { Project } from '../models/Project';
import { DeepCopyService } from './deep-copy.service';

@Injectable({
  providedIn: 'root'
})
export class RouterService {
  public currentPage: string;

  constructor(public router: Router,
    public outcomeService: OutcomesService,
    public assetManagementService: AssetManagementService,
    public authorService: AuthorService,
    public projectsService: ProjectsService,
    public authenticationService: AuthenticationService,
    public learnerService: LearnerService,
    public usageService: CustomerUsageService,
    public customerService: CustomerService,
    public cryptoService: CryptoService,
  ) {

    // Other events that might be helpful:
    // NavigationEnd
    // NavigationCancel
    // NavigationError
    // RoutesRecognized
    //if (!this.authenticationService.redirectTo2FA()) {

    if (localStorage.getItem('valid') != null) {
      this.authenticationService.isLoggedIn = localStorage.getItem('valid') == "true" ? true : false;
    }

    this.router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        this.currentPage = event.url;
        this.authorService.runAutosave = false;
        this.checkLicenseStatus();

        if (event.url != '/author') {
          if (this.cryptoService.decryptData(localStorage.getItem('project')) != null) {
            localStorage.removeItem('project');
          }
        }

        switch (event.url) {
          case '/outcomes': {
            this.outcomeService.reinitOutcomes();
            break;
          }
          case '/assets': {
            this.assetManagementService.reinitAssets();
            break;
          }
          case '/projects': {
            this.projectsService.reinitProjects();
            break;
          }
          case '/author': {
            this.authorService.movingObject = null;
            this.authorService.selectedAsset = null;
            this.authorService.leftToolbarIndex = 0;
            break;
          }
          case '/login': {
            if (this.authenticationService.isLoggedIn) {
              this.router.navigateByUrl('/home');
            }
            break;
          }
          case '/registration': {
            if (this.authenticationService.isLoggedIn) {
              this.router.navigateByUrl('/home');
            }
            break;
          }
          case '/learners': {
            this.learnerService.reinitLearners();
            break;
          }
          case '/my-profile': {
            if (!this.authenticationService.isLoggedIn) {
              this.router.navigateByUrl('/login');
            }
            break;
          }
          case '/two-factor-authentication': {
            if (!this.authenticationService.isLoggedIn) {
              this.router.navigateByUrl('/login');
            }
            break;
          }
          case '/404': {
            if (!this.authenticationService.isLoggedIn) {
              this.router.navigateByUrl('/login');
            }
            break;
          }
        }
        this.checkUserLoginStatus();
      }
    });

    // }
    // else {
    //   this.router.navigateByUrl('/two-factor-authentication');
    // }
  }

  checkLicenseStatus() {
    if (this.cryptoService.decryptData(localStorage.getItem("login_r")) != "sa") {
      if (this.cryptoService.decryptData(localStorage.getItem('customerId')) != null && this.cryptoService.decryptData(localStorage.getItem('customerId')) != '0') {
        this.customerService.getCustomerByCustomerId().then(x => {
          if (this.customerService.checkIfExpired()) {
            if (this.cryptoService.decryptData(localStorage.getItem("login_r")) == "ad") {
              if (this.currentPage != '/my-account') {
                this.router.navigateByUrl('/my-account');
              }
            }
            else {
              if (this.currentPage != '/contact-admin') {
                this.router.navigateByUrl('/contact-admin');
              }
            }
          }
        })
      }
    }
  }

  checkUserLoginStatus() {
    if (this.currentPage != '/login' && this.authenticationService.isLoggedIn) {
      if (this.cryptoService.decryptData(localStorage.getItem('customerId')) == null || this.cryptoService.decryptData(localStorage.getItem('customerId')) == '0') {
        this.authenticationService.logOut();
      }
    }
  }
}
